import React from 'react';

import { Table, Column, HeaderCell, Cell, ColumnGroup} from 'rsuite-table';
import 'rsuite-table/dist/css/rsuite-table.css';

const baseTableProps = {
    height: 720,
};

const baseStyles = {
    zIndex: 0,
}
export const ManageSongGrid = ({dataSource, onRowClick}) => {
    return (
     <Table data={dataSource} {...baseTableProps} style={baseStyles} onRowClick={onRowClick}>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Track Title</HeaderCell>
                <Cell>{rowData => rowData.title}</Cell>
            </Column>
            <Column width={200} fixed sortable resizable>
                <HeaderCell>Artist</HeaderCell>
                <Cell>{rowData => rowData.artist}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Track Duration</HeaderCell>
                <Cell>{rowData => rowData.duration}</Cell>
            </Column>
            <Column width={100} fixed sortable resizable>
                <HeaderCell>Is Explicit</HeaderCell>
                <Cell>{rowData => (
                         <input
                             type="checkbox"
                             checked={rowData.explicit}
                             onChange={event => {
                                 event.stopPropagation();
                                //  onRowClick(rowData);
                             }}
                             style={{ marginLeft: 10 }}
                             disabled
                         />
                )}</Cell>
            </Column>
            <Column width={250} fixed sortable resizable>
                <HeaderCell>Additional Artists</HeaderCell>
                <Cell>{rowData => rowData.additionalArtists}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>Publisher</HeaderCell>
                <Cell>{rowData => rowData.publisher}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>ISRC</HeaderCell>
                <Cell>{rowData => rowData.ISRC}</Cell>
            </Column>
            <Column width={140} fixed sortable resizable>
                <HeaderCell>Release Date</HeaderCell>
                <Cell>{rowData => new Date(rowData.releaseDate).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                    })}
                </Cell>
            </Column>
        </Table>
    )
}